import React from 'react';
import { CustomPrice } from './CustomPrice';
export const CustomPrices = ({ customPrices }) => {
    if (!customPrices)
        return null;
    return (React.createElement(React.Fragment, null, customPrices.map((price, index, self) => {
        return (React.createElement(CustomPrice, { price: price, index: index, key: price.path, isLastItem: index === self.length - 1 }));
    })));
};
